define('jqueryValidationMessagesDe',{
    "Please enter your name"    : "Bitte geben Sie Ihren Namen ein",
    "Please enter your email address": "Bitte geben Sie eine Email Adresse an",
    "Numbers are not allowed"   : "Nummern sind nicht erlaubt",
    "Your name is too short"    : "Der Name is zu kurz",
    "Please enter a valid email address" : "Bitte geben Sie eine gültige E-Mail-Adresse an",
    "Please enter a message": "Bitte geben Sie Ihre Nachricht ein",
    "Please enter the numbers or words from the image above" : "Bitte geben Sie die Nummer oder Wörter aus dem Bild oben hier ein"
});
